import { useApiQuery } from 'theSource/utils';
import { SubscriberCommunicationPreferencesResponseDto } from './types';
import { GET_SUBSCRIBER_COMMUNICATION_PREFERENCES_KEY } from './utils';

export interface UseSubscriberCommunicationPreferencesQueryProps {
  enabled: boolean;
  lumosApiHost: string;
}

export const useSubscriberCommunicationPreferencesQuery = ({
  enabled,
  lumosApiHost,
}: UseSubscriberCommunicationPreferencesQueryProps) => {
  const { data, isLoading, isFetching } =
    useApiQuery<SubscriberCommunicationPreferencesResponseDto>({
      queryKey: GET_SUBSCRIBER_COMMUNICATION_PREFERENCES_KEY,
      config: {
        baseURL: `${lumosApiHost}/v2/self_service`,
      },
      endpoint: '/employees/communication_preferences',
      enabled: enabled,
    });

  return {
    data,
    isLoading,
    isFetching,
  };
};
